import { CommitmentsScenariosService } from '@festina/life-general-types/life/services/CommitmentsScenariosService'
import { useFestinaMutation } from '@festina-life/authentication'
import { assertNotEmpty, type Except } from '@festina-life/core'

type Props = {
  tenantId: string
  ownerId: string
}

const method =
  CommitmentsScenariosService.commitmentScenarioVersionServicePostUpdateEntity
type MethodParam = Parameters<typeof method>[0]

export const useSubmitUpdateScenario = ({ tenantId, ownerId }: Props) =>
  useFestinaMutation({
    component: 'life',
    roles:
      CommitmentsScenariosService.commitmentScenarioVersionServicePostUpdateEntity_roles,
    isScenario: false,
    mutateFunction: async (
      arg: Except<MethodParam, 'ownerId' | 'xTenantId'>,
    ) => {
      assertNotEmpty(arg.scenarioId)
      await method({
        xTenantId: tenantId,
        ownerId,
        ...arg,
      })
    },
  })
